<template>
<main class="l-contents mt-4">
  <div class="title1">
    <div v-t="'translatedByMachine'"></div>
    <h2 class="title1_title"><span class="title1_mainLabel" v-t="'terms.title'"></span></h2>
  </div>
  <div
    v-for="i in 27" :key="i"
    class="sub-wrapper"
  >
    <div class="sub-title">{{ $t('terms.subTitle_' + i) }}</div>
    <div class="sub-content">
      <span v-t="'terms.subContent_'+ i"></span>
      <!-- {{ $t('' + i) }} -->
    </div>
  </div>
</main>
</template>

<script>
export default {
  name: 'Terms'
}
</script>

<style>

</style>
